module.exports = __webpack_public_path__ + "761853435a18524a9107b46840cf2730.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W12.jpg
// module id = 3492
// module chunks = 0